import axios from 'axios';
import { useState } from 'react';
import '../../CSS/DeleteAccountRequest.css';

const DeleteAccountRequest = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setStatus('Please enter both email and password.');
      return;
    }

    setLoading(true);
    setStatus('');

    try {
      const { data } = await axios.delete(
        'https://motomate.cbtech.com.np/api/user/permanent',
        {
          data: { email, password }, // axios uses `data`, not `body`
        }
      );

      if (data.success) {
        setStatus('✅ Your account has been permanently deleted.');
      } else {
        setStatus(`❌ ${data.message || 'Failed to delete account.'}`);
      }
    } catch (error) {
      setStatus(
        `❌ ${error?.response?.data?.message || 'An error occurred. Please try again later.'}`
      );
    }

    setLoading(false);
  };

  return (
    <div className="delete-account-container">
      <h2>Delete Your MotoMate Account</h2>
      <p>To permanently delete your account and data, please confirm your email and password.</p>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        /><br />
        <input
          type="password"
          placeholder="Your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        /><br />

        <button type="submit" disabled={loading}>
          {loading ? 'Processing...' : 'Delete My Account'}
        </button>
      </form>

      {status && <p className="status-message">{status}</p>}
    </div>
  );
};

export default DeleteAccountRequest;
